import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, initialize, FieldArray } from 'redux-form';
import { NavLink } from "react-router-dom";
import { SiteWrapper } from "../common";
import { Page, Card, Button, Form, Dimmer, Alert } from "tabler-react";
import { Multiselect, DropdownList } from 'react-widgets';
import { getUser, findRoles, createUser, updateUser, deleteUser, findStaffs } from '../actions';
import { confirmAlert } from 'react-confirm-alert';
import Auth from '../auth/auth';

const auth = new Auth({});

class UserFormPage extends Component {

  componentDidMount() {

    const { id } = this.props.match.params;
    if (id) {
      this.getUser(id);
      let alert = localStorage.getItem('createUser');
      if (alert) {
        alert = JSON.parse(alert);
        this.setState({ alert });
        localStorage.removeItem('createUser');
      }
    }

    if (!this.props.roles.items)  {
      this.props.findRoles(1, 100000);
    }

    this.props.findStaffs();
  }

  constructor(props) {
    super(props);

    this.state = {
      user: {},
      getUserLoader: false,
      submitLoader: false,
      deleteLoader: false,
      alert: {
        display: false,
        type: '',
        icon: '',
        message: ''
      },
    };

    this.renderTextField = this.renderTextField.bind(this);
    this.renderAsterisk = this.renderAsterisk.bind(this);
    this.renderMultiselect = this.renderMultiselect.bind(this);
    this.renderTextAreaField = this.renderTextAreaField.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleOnDelete = this.handleOnDelete.bind(this);
    this.renderStaffFields = this.renderStaffFields.bind(this);
    this.populateStaffs = this.populateStaffs.bind(this);

  }

  onSubmit(values) {
    console.log('onSubmit', values);
    const { id } = this.props.match.params;
    let roles = [];

    for(let r of values.userRoles) roles.push(r.id);
    values.roles = [...roles];

    if (values.staffs)
      for (let s of values.staffs) s.staffNum = s.staff.value;

    this.setState({ submitLoader: true });

    if (!id) {
      this.props.createUser(values, (response) => {
          console.log('createUser', response);
          this.setState({ submitLoader: false });
          localStorage.setItem('createUser', JSON.stringify({ display: true, icon: 'check', type: 'success', message: 'User successfully created.' }));
          this.props.history.push(`/users/${response.data.id}`);
      }, (error) => {
        console.log('createUser', error);
        this.setState({ submitLoader: false, alert: { display: true, icon: 'alert-triangle', type: 'danger', message: 'Unable to create new user.' } });
      });
    }
    else {
      this.props.updateUser(values, (response) => {
        console.log('updateUser', response);
        this.setState({ submitLoader: false, alert: { display: true, icon: 'check', type: 'success', message: `User successfully updated.` }});
      }, (error) =>{
        console.log('updateUser', error);
        this.setState({ submitLoader: false, alert: { display: true, icon: 'alert-triangle', type: 'danger', message: 'Unable to update user.' } });
      });
    }


  }

  handleOnDelete() {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Card>
            <Card.Body>
              <h3>Are you sure?</h3>
              <p>You want to delete this user?</p>
              <Button.List>
                <Button type="button" color="secondary" onClick={onClose}>No</Button>
                <Button type="button" color="danger" onClick={() => {
                    this.onDelete();
                    onClose();
                }}>Yes</Button>
              </Button.List>
            </Card.Body>
          </Card>
        )
      }
    });
  }

  onDelete() {
    const { id } = this.props.match.params;
    this.setState({ deleteLoader: true });
    this.props.deleteUser(id, (response) => {
      console.log('deleteUser', response);
      localStorage.setItem('deleteUser', JSON.stringify({ display: true, icon: 'check', type: 'success', message: `User successfully deleted.` }));
      this.props.history.push(`/users`);
    }, (error) => {
      console.log('deleteUser', error);
      this.setState({ deleteLoader: false, alert: { display: true, icon: 'alert-triangle', type: 'danger', message: 'Unable to delete user.' } });
    });
  }

  populateRoles() {
    if (!this.props.roles.items) return [];
    let roles = this.props.roles.items;
    roles.forEach(r => { r.label = `${r.type}/${r.name}`; return r; });
    return roles;
  }

  populateStaffs() {
    if (!this.props.staffs.items) return [];
    return this.props.staffs.items.map(i => { return { value: i.klNo, label: i.klNo.replace('KL', '') } });
  }

  getUser(id) {
    this.setState({ getUserLoader: true });
    this.props.getUser(id, (response) => {
      console.log('getUser', response);
      let { data } = response;
      data.userRoles = [...data.roles];
      data.userRoles.forEach(f => { f.label = `${f.type}/${f.name}`; return f; });
      data.staffs.forEach(s => { s.staff = { value: s.staffNum, label: s.staffNum.replace('KL', '') }; return s; });
      this.props.initialize('UserForm', response.data);
      this.setState({ getUserLoader: false, user: response.data });
    });
  }


  renderAsterisk(isRequired) {
    let asterisk ;
    if (isRequired) asterisk =  <span className="text-danger">*</span>;
    return asterisk;
  }

  renderTextField(field) {
    const { meta: { touched, error }, label, input, isRequired, type, value } = field;
    return (
       <Form.Group>
         {label &&
           <Form.Label>{label} {this.renderAsterisk(isRequired)}</Form.Label>
         }
         <Form.Input
           value={value ? value : ''}
           type={type ? type : 'text'}
           feedback={error}
           invalid={touched && error ? 'invalid' : undefined}
           {...input}
          />
       </Form.Group>
    );
  }

  renderTextAreaField(field) {
    const { meta: { touched, error }, label, input, isRequired, rows } = field;

    return (
       <Form.Group>
         {label &&
           <Form.Label>{label} {this.renderAsterisk(isRequired)}</Form.Label>
         }
         <Form.Textarea
           feedback={error}
           invalid={touched && error ? 'invalid' : undefined}
           {...input}
           rows={rows ? rows : 3}
         />
       </Form.Group>
    );
  }

  renderMultiselect({ input, data, valueField, textField, isRequired, label }) {
    return (
      <Form.Group>
          <Form.Label>{label} {this.renderAsterisk(isRequired)}</Form.Label>
          <Multiselect
            {...input}
            onBlur={() => input.onBlur()}
            value={input.value || []} // requires value to be an array
            data={data}
            valueField={valueField}
            textField={textField}
          />
      </Form.Group>
    );
  }

  renderAlert() {
    return (
      <div>
        {this.state.alert.display &&
          <Alert type={this.state.alert.type} icon={this.state.alert.icon} isDismissible>
            {this.state.alert.message}
          </Alert>
        }
      </div>
    );
  }

  renderDropdownList({ input, data, valueField, textField }) {
    return (
      <DropdownList {...input}
        data={data}
        filter
        valueField={valueField}
        textField={textField}
        valueComponent={({item}) => (
          <span>
            <strong>KL</strong>{item[textField]}
          </span>
        )}
        onChange={input.onChange} />
    );
  }

  renderStaffFields({ fields }) {

    return (
      <div>
        <hr className="mt-5 mb-4" />
        <Button type="button" color="primary" className="float-right" size="sm" icon="plus" onClick={() => fields.push({})}>Add Staff</Button>
        <table className="table">
          <thead>
            <tr>
              <th>Staff Num</th>
              <th width="200">PassCode</th>
              <th width="80">Action</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((f, i) => (
              <tr key={i}>
                <td>
                  <Field name={`${f}.staff`} component={this.renderDropdownList} data={this.populateStaffs()} valueField="value" textField="label" />
                </td>
                <td>
                  <Field name={`${f}.passCode`} type="text" component="input" className="form-control" />
                </td>
                <td>
                  <Button color="danger" size="sm" icon="trash" type="button" onClick={() => fields.remove(i)}></Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {

    const { handleSubmit } = this.props;
    const { id } = this.props.match.params;

    return(
      <SiteWrapper>
          <Page.Content>
            {this.renderAlert()}
            <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <Card>
                <Card.Header>
                  <Card.Title>
                     {!id ? 'New User' : this.state.user.userName}
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Dimmer active={this.state.getUserLoader} loader>
                      <div className="row">
                          <div className="col-md-6">
                            {!id &&
                              <Field label="User Name" name="userName" isRequired="true" component={this.renderTextField} />
                            }
                            <Field label="Email" name="email" type="email" isRequired="true" component={this.renderTextField} />
                            <Field label="Roles" name="userRoles" isRequired="true" textField="label" valueField="id" component={this.renderMultiselect} data={this.populateRoles()} />
                            <Field name="id" type="hidden" component={this.renderTextField} />
                            <Field label="Password" name="password" type="password" isRequired={id ? false : true} component={this.renderTextField} />
                          </div>
                          <div className="col-md-6">
                            <Field label="Note" name="note" component={this.renderTextAreaField} />
                            {/* <FieldArray name="staffs" component={this.renderStaffFields} /> */}
                          </div>
                      </div>
                 </Dimmer>
                </Card.Body>
                <Card.Footer>
                  <div className="d-flex">
                    <NavLink to="/users">
                      <Button color="secondary">Back</Button>
                    </NavLink>
                    {(id && auth.hasAccess('user', 'delete')) &&
                      <Button loading={this.state.deleteLoader} onClick={this.handleOnDelete} className="ml-auto" color="danger" type="button">Delete</Button>
                    }
                    {(!id || auth.hasAccess('user', 'update')) &&
                      <Button loading={this.state.submitLoader} color="success" className={id && auth.hasAccess('user', 'delete') ? 'ml-2' : 'ml-auto'}>Submit</Button>
                    }
                  </div>
                </Card.Footer>
              </Card>


             </Form>
          </Page.Content>
      </SiteWrapper>
    );
  }
}


function validate(values) {
  const errors = {};

  if (!values.userName)  {
    errors.userName = 'Required Field';
  }

  if (!values.email)  {
    errors.email = 'Required Field';
  }

  if (!values.userRoles || values.userRoles.length < 0)  {
    errors.userRoles = 'Required Field';
  }

  if (!values.id && !values.password)  {
    errors.password = 'Required Field';
  }

  return errors;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
      findRoles, createUser, getUser, initialize, updateUser, deleteUser, findStaffs
  }, dispatch);
}

function mapStateToProps({ roles, staffs }) {
  return { roles, staffs };
}

export default reduxForm({
  validate,
  form: 'UserForm'
})(connect(mapStateToProps, mapDispatchToProps)(UserFormPage))



// WEBPACK FOOTER //
// ./src/user/user-form.react.js